// Handler to disable the next button in the calendar
export const disableNextButton = () => {
    const nextButton = document.getElementsByClassName('p-datepicker-next p-link')[0];
    nextButton?.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
    });
};
